/**
 * No-op node hover program for Sigma.js
 * This program class does nothing, preventing Sigma from drawing node circles during hover
 * while still allowing the custom hover renderer (drawHoveredNodeLabel) to execute.
 */

import { NodeDisplayData } from "sigma/types";

// Create a minimal WebGL program that does nothing
export default class NoOpNodeProgram {
  constructor(gl, renderer, sigma) {
    this.gl = gl;
    this.renderer = renderer;
    this.sigma = sigma;
  }

  allocate(capacity) {
    // No-op: Don't allocate any GPU buffers
  }

  reallocate(capacity) {
    // No-op: Don't reallocate buffers
  }

  process(offset, index, data) {
    // No-op: Don't process any node data
  }

  render(params) {
    // No-op: Don't render anything
    // This is the key method - by not rendering, we prevent the WebGL circle from obscuring labels
  }

  kill() {
    // No-op: Nothing to clean up
  }
}